The unit of measure from the UN/CEFACT Unit Codes for Trade (2014, Annex II & Annex III).

Currently, this will always be "WEE", representing "week".
